﻿import { Output } from "@models/configurators/outputs/output";
import { FileOutput } from "@models/configurators/outputs/file-output";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IOutput, IWordOutput } from "@models/entity-models";
import { eOutputType } from "@models/enums";
import { Kbo, KboOutput } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutput(CToken.WordOutput, eOutputType.word)
export class WordOutput extends FileOutput implements IWordOutput {
    constructor(kom: KbObjectManager, args?: IOutput) {
        super(kom, args);
        this.type = eOutputType.word;
    }
}
